import React from 'react'
import { telephone, whatsapp } from '../../assets'

function CTA() {
  return (
    <section id='cta' className='background-secondary'>
      <div className="container text-center text-light">
        <div className="row mb-5 text-dark">
          <h2 className='mb-3 fw-bold'>Hubungi Kami</h2>
          <p className='desc'>Customer Service kami siap membantu 24/7</p>
        </div>
        <div className="d-flex justify-content-evenly align-items-center flex-wrap" style={{rowGap: "30px"}}>
          <a 
            className="border border-1 rounded-4 p-5 bg-light cta" 
            data-aos="fade-right" 
            data-aos-duration="1000"
            href="tel:085241329911"
          >
            <img src={telephone} alt="telephone" className='m-auto mb-4'/>
            <p className='text-dark fw-bold fs-5 m-0'>Telepon</p>
          </a>
          <a 
            className="border border-1 rounded-4 p-5 bg-light cta" 
            data-aos="fade-left" 
            data-aos-duration="1000"
            href="https://api.whatsapp.com/send/?phone=6285241329911&text=Hallo+Black+Canyon+Transport+,%20Saya%20mau%20pesan%20mobil..."
            target="_blanks"
          >
            <img src={whatsapp} alt="whatsapp" className='m-auto mb-4'/>
            <p className='text-dark fs-5 fw-bold m-0'>Whatsapp</p>
          </a>
        </div>
      </div>
    </section>
  )
}

export default CTA